
    <p style="text-align: center; margin: 0"><i class="{{renderValue}}"></i></p>
  


// WEBPACK FOOTER //
// ./src/app/pages-crypto/renderer-crypto/boolean-renderer.ts.BooleanRenderComponent.html